import _ from 'lodash';
import 'map-tools/dist/scripts/nrelmt-no-libs';

// The `map-tools/dist/scripts/nrelmt-no-libs` library needs to have lodash
// globally defined in order to work, so this wrapper ensures this global is
// setup.
window._ = _;

// The `map-tools/dist/scripts/nrelmt-no-libs` import isn't really an ES6
// module, but instead exposes the variable on a global. This wrapper just
// hides the global behind a module export for easier importing.
const NRELMT = window.NRELMT;

export default NRELMT;
